import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import "./Reports.scss";
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    PointElement,
    LineElement,
    LineController,
} from "chart.js";
import MultiSelectBox from "../../utilities/MultiSelectBox/MultiSelectBox";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { useSelector } from "react-redux";
import { getAllMachineData } from "../../redux/reducers/machineReducers";
import { getMultipleMachinePileData, getSingleMachinePileData } from "../../redux/reducers/reportReducer";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import SingleRigReport from "./RigWiseReport/SingleRigReport";
import MultipleRigReport from "./RigWiseReport/MultipleRigReport";
ChartJS.register(
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    PointElement,
    LineElement,
    LineController
);

const RigWiseReport = () => {

    const [rigFilter, setRigFilter] = useState({ from: '', to: '' });
    const [multiRigFilter, setMultiRigFilter] = useState({ from: '', to: '' });

    const [multipleRigNames, setMultipleRigNames] = useState([]);
    const [multipleRigs, setMultipleRigs] = useState([]);

    const [projectList, setProjectList] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");

    const [rigList, setRigList] = useState([]);
    const [rigName, setRigName] = useState("");
    const [rigId, setRigId] = useState("");

    const [stepDetails, setStepDetails] = useState([]);

    const [showSingleGraph, setShowSingleGraph] = useState(false);
    const [showMultipleGraph, setShowMultipleGraph] = useState(false);

    const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
    const allMachineData = useSelector((state: any) => state.MACHINE.allMachineData);
    const singleMachinePileData = useSelector((state: any) => state.REPORT.singleMachinePileData);
    const multipleMachinePileData = useSelector((state: any) => state.REPORT.multipleMachinePileData);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(
            getAllProjectData({
                endPoint: `project/get-all-projects`,
            })
        );
        // eslint-disable-next-line
    }, []);

    const populateListData = (listData: any, identifier: string, storeFunc: any) => {
        let arr: any = [];
        listData?.forEach((val: any) => {
            arr.push(val[identifier]);
        });
        storeFunc(arr);
    }

    useEffect(() => {
        populateListData(allProject, 'projectName', setProjectList);
    }, [allProject]);

    useEffect(() => {
        allMachineData?.length ? populateListData(allMachineData, 'machineDetail', setRigList) : setRigList([]);
    }, [allMachineData]);

    useEffect(() => {

        setStepDetails(getStepDetails(projectId));

        dispatch(
            getAllMachineData({
                endPoint: `machine/list?status=&project=${projectId}&type=Rig&strict=true`,
            })
        );
        resetSingleValue();
        // eslint-disable-next-line
    }, [projectId]);

    //set id method
    const setObjectId = (
        list: Array<any>,
        index: any,
        setMethod: Function,
        key: string
    ) => {
        setMethod(list[index][key]);
    };

    const setIdsFromNames = (
        list: Array<any>,
        nameList: Array<any>,
        targetList: Array<any>,
        setMethod: Function,
        key: string) => {
        if (list.length > 0 && nameList.length > 0 && targetList.length > 0) {
            const result = [];
            for (let i = 0; i < targetList.length; i++) {
                const index = nameList?.map((item: any) => item).indexOf(targetList[i]);
                if (index >= 0)
                    result.push(list[index][key]);
            }
            setMethod(result);
        }
    }

    const handleFilterDate = () => { }

    const resetToAll = () => { }

    const changeResetValue = () => { };

    const resetSingleValue = () => {
        setRigList([]);
        setRigName("");
        setRigId("");
        setShowSingleGraph(false);
    }

    const resetMultipleValue = () => {
        setRigList([]);
        setMultipleRigNames([]);
        setMultipleRigs([]);
        setShowMultipleGraph(false);
    }

    const handleSingleRigSearch = () => {
        dispatch(
            getSingleMachinePileData({
                endPoint: `reports/single-machine-report`,
                data: { projectId, machine: rigId, startDate: rigFilter.from, endDate: rigFilter.to }
            })
        );
        setShowSingleGraph(true);
    }

    const handleMultiRigSearch = () => {
        dispatch(
            getMultipleMachinePileData({
                endPoint: `reports/multiple-machine-report`,
                data: { projectId, machines: multipleRigs, startDate: multiRigFilter.from, endDate: multiRigFilter.to }
            })
        );
        setShowMultipleGraph(true);
    }

    const getStepDetails = (projectId: string) => {
        const selectProject = allProject.find((project: any) => project._id === projectId);
        if (selectProject) {
            return selectProject.pileInformation?.map((step: any) => ({ stepName: step.stepName, stepNumber: step.stepNumber, value: step.idealCompletionTime }))
        }
        return [];
    }

    return (
        <Grid container className="bg--white box--shadow mt1 p1">
            <Grid className="standared_width">
                <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                    <span className="fw500">Select Project</span>
                </Text>
                <SelectBox
                    data={projectList}
                    placeHolder="Select Project"
                    defaultVal={projectName}
                    resetVal={projectName === "" ? true : false}
                    changeReset={changeResetValue}
                    onChange={(e) => {
                        resetSingleValue();
                        resetMultipleValue();
                        let target = { ...e };
                        setProjectName(target.target.value);
                        const index = projectList
                            ?.map((item: any) => item)
                            .indexOf(target.target.value);
                        setObjectId(allProject, index, setProjectId, "_id");
                    }}
                    borderColor={"primary"}
                />
            </Grid>
            <Grid container className="bg--white box--shadow mt1 plr-1">
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={3}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={16}
                            className="mb0 mt1"
                        >
                            <span className="fw500">Select Rig</span>
                        </Text>
                        <SelectBox
                            data={rigList}
                            placeHolder="Select Rig"
                            defaultVal={rigName}
                            resetVal={rigName === "" ? true : false}
                            changeReset={changeResetValue}
                            onChange={(e) => {
                                let target = { ...e };
                                setRigName(target.target.value);
                                const index = rigList
                                    ?.map((item: any) => item)
                                    .indexOf(target.target.value);
                                setObjectId(allMachineData, index, setRigId, "id");
                            }}
                            borderColor={"primary"}
                        />
                    </Grid>
                    <Grid item className={"mt2 ml-1"}
                        direction="row"
                        alignItems="center">
                        <div className="filter_box filter_margin">
                            <FilterComponent
                                handleFilterDate={handleFilterDate}
                                setValue={setRigFilter}
                                value={rigFilter}
                                resetAll={resetToAll}
                            />
                        </div>
                    </Grid>
                    <Grid item className="mt2 ml-1">
                        <Button
                            type="button"
                            size="medium"
                            isRounded={true}
                            category="primary"
                            onClick={() => {
                                handleSingleRigSearch()
                            }}
                            className="submit_button mb1 mt3 mr-1 pl pr f14"
                        >
                            <SVG type={"searchIcon"} />
                            Search
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0"
                        >
                            <span className="fw500">Selected RIG Report</span>
                        </Text>
                    </Grid>
                </Grid>

                {
                    showSingleGraph ?
                        <SingleRigReport machineData={singleMachinePileData} stepDetails={stepDetails} /> :
                        <SelectOptionMsg text={`Select rig to view Machine information`} />
                }


            </Grid>


            <Grid container className="bg--white box--shadow mt1 p1">
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Multiple RIG Report</span>
                        </Text>
                    </Grid>
                </Grid>
                <Grid xs={12} container>
                    <Grid xs={12} item>
                        <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
                            <span className="fw500">Select Multiple Rig (max 8)</span>
                        </Text>
                    </Grid>
                    <Grid xs={5} item>
                        <MultiSelectBox
                            selectData={{
                                data: rigList,
                                name: "multiSelect",
                                disabled: false,
                                placeHolder: "Choose RIG",
                                value: multipleRigNames,
                                borderColor: "primary",
                                defaultValue: multipleRigNames,
                                onChange: (e: any) => {
                                    const selectedRigs = e.target.value;
                                    if (selectedRigs.length <= 8) {
                                        setMultipleRigNames(e.target.value)
                                        setIdsFromNames(allMachineData, rigList, e.target.value, setMultipleRigs, 'id')
                                    }
                                },
                            }}
                        />
                    </Grid>
                    <Grid item className={"ml-1"}
                        direction="row"
                        alignItems="center">
                        <div className="filter_box_ml">
                            <FilterComponent
                                handleFilterDate={handleFilterDate}
                                setValue={setMultiRigFilter}
                                value={multiRigFilter}
                                resetAll={resetToAll}
                            />
                        </div>
                    </Grid>
                    <Grid item className="mt2 ml-1">
                        <Button
                            type="button"
                            size="medium"
                            isRounded={true}
                            category="primary"
                            onClick={() => {
                                handleMultiRigSearch()
                            }}
                            className="submit_button mb1 mr-1 pl pr f14"
                        >
                            <SVG type={"searchIcon"} />
                            Search
                        </Button>
                    </Grid>
                </Grid>

                {showMultipleGraph ? <MultipleRigReport machineData={multipleMachinePileData} machineNames={multipleRigNames} /> : (
                    <SelectOptionMsg
                        text={`Select rigs to view Machine information`}
                    />
                )}
            </Grid>
        </Grid>
    )
}

export default RigWiseReport;